import React, { useState } from "react";
import InnerTabList from "components/InnerTabList/InnerTabList";
import StatisticsOfflineMerchant from "./OfflineMerchant/StatisticsOfflineMerchant";
import OnlineMerchant from "./OnlineMerchant/StatisticsOnlineMerchant";
import s from "./system-statistics.module.scss";
import StatisticsOfflineTransaction from "./OfflineTransaction/StatisticsOfflineTransaction";
import StatisticsSalesperson from "./Salesperson/StatisticsSalesperson";
import StatisticsOnlineTransaction from "./OnlineTransaction/StatisticsOnlineTransaction";

const SystemStatistics = () => {
  const [selectedTab, setSelectTab] = useState("offlineMerchant"); //CHANGE

  const innerTabContainer = () => {
    const tabList = [
      {
        key: "offlineMerchant",
        label: "Offline Merchants",
        value: "offlineMerchant",
      },
      {
        key: "offlineTransaction",
        label: "Offline Transactions",
        value: "offlineTransaction",
      },
      {
        key: "onlineMerchant",
        label: "Online Merchants",
        value: "onlineMerchant",
      },
      {
        key: "onlineTransaction",
        label: "Online Transactions",
        value: "onlineTransaction",
      },
      {
        key: "salesperson",
        label: "Salespersons",
        value: "Salespersons",
      },
    ];

    const changeSelectedTab = (event, innerTabName) => {
      setSelectTab(innerTabName);
    };

    return (
      <InnerTabList
        selectedTab={selectedTab}
        handleChangeTab={changeSelectedTab}
        tabList={tabList}
      />
    );
  };

  const list = {
    offlineMerchant: (
      <StatisticsOfflineMerchant focus={selectedTab === "offlineMerchant"} />
    ),
    offlineTransaction: (
      <StatisticsOfflineTransaction
        focus={selectedTab === "offlineTransaction"}
      />
    ),
    onlineMerchant: <OnlineMerchant focus={selectedTab === "onlineMerchant"} />,
    onlineTransaction: (
      <StatisticsOnlineTransaction
        focus={selectedTab === "onlineTransaction"}
      />
    ),
    Salespersons: (
      <StatisticsSalesperson focus={selectedTab === "Salespersons"} />
    ),
  };

  return (
    <div className={s["container"]}>
      <div className={s["inner-tab-container"]}>{innerTabContainer()}</div>
      <div className={s["content-container"]}>
        {Object.entries(list).map(([key, value]) => (
          <div
            key={key}
            style={{
              height: "100%",
              ...(selectedTab !== key && { display: "none" }),
            }}
          >
            {value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(SystemStatistics);
